export enum Constants {
  EDIT_DOCUMENT_INTRO_HAS_PLAYED = 'edit-document-intro-has-played',
  SUPPORT_PORTAL_BASE_URL = 'https://blabberjax.atlassian.net/wiki/spaces/BKP/',
  SUPPORT_TICKET_URL = 'https://airtable.com/appETyqdO92stApnJ/shryhk17IkZbra8ms'
}

export interface PartialHeadingInfo {
  shortDescription: string;
  helpLink?: string;
  helpLinkText?: string;
  helpLinkCssClass?: string;
  helpIconCssClass?: string;
}

const HeadingInfoSet: {
  Themes: PartialHeadingInfo,
  Articles: PartialHeadingInfo,
  SocialSetup: PartialHeadingInfo,
  Webhooks: PartialHeadingInfo,
  Projects: PartialHeadingInfo,
  SeoSetup: PartialHeadingInfo,
  ContentGraph: PartialHeadingInfo,
  PromptChains: PartialHeadingInfo,
  Welcome: PartialHeadingInfo,
  TopicExplorer: PartialHeadingInfo
} = {
  Themes: {
    shortDescription: 'Use themes to organize your content or add a target date to them to treat them like campaigns.',
    helpLink: '',
    helpLinkText: ''
  },
  Articles: {
    shortDescription: 'This is your content schedule, divided up by project.  Use the dropdown on the top right to quickly switch to another project workspace.',
    helpLink: '',
    helpLinkText: ''
  },
  SocialSetup: {
    shortDescription: 'Click on the buttons below to authenticate to all of your social media accounts.',
    helpLink: '',
    helpLinkText: ''
  },
  Webhooks: {
    shortDescription: 'For more information about setting up a webhook, including sample source code please read our ',
    helpLink: 'https://blabberjax.atlassian.net/wiki/x/AYCrGQ',
    helpLinkText: 'API & Webhooks Guide.'
  },
  Projects: {
    shortDescription: '',
    helpLink: '',
    helpLinkText: ''
  },
  SeoSetup: {
    shortDescription: 'To get started with SEO analysis enter the absolute URL for your website\'s sitemap. Please note that we currently only support analyzing a single sitemap for a website.',
    helpLink: '',
    helpLinkText: ''
  },
  ContentGraph: {
    shortDescription: 'This is a graph of all of the content in your sitemap and how it links together. Use the search bar below to filter by different keywords.',
    helpLink: '',
    helpLinkText: ''
  },
  PromptChains: {
    shortDescription: 'Prompt Chains are templatized messages sent to AI models to generate articles and other content.  From here you have complete access to customize how every piece of content is generated.',
    helpLink: '',
    helpLinkText: ''
  },
  Welcome: {
    shortDescription: `<p>We'll help you grow your brand with high-impact content spells. 
    To get started, click on the button below to create your first article now.</p>

    <div class="row justify-content-center">
      <div class="col-md-auto">
        <a href="/documents/edit/new?gn.key=article-generation-guide-1&gn.stage_number=1&utm_source=in-app&utm_medium=welcome-banner"
          target="_blank" rel="noreferrer"
          class="btn btn-primary btn-magic btn-lg d-inline-flex align-items-center">
          <i class="bi bi-magic me-2"></i>
          Create your first article
        </a>
      </div>
      <div class="col-md-auto" style="font-style: italic; margin-top: .3em; font-size: .9em; text-align: left;">
        It takes less than 2 minutes <br /> no setup required!
      </div>
    </div>

    <p class="text-muted" style="font-size:.8em; margin-top:1em;">
      Need more help? Visit our 
      <a href="${Constants.SUPPORT_PORTAL_BASE_URL}overview?utm_source=in-app&utm_medium=welcome-banner" 
        target="_blank" rel="noreferrer  ">
        support portal</a>.
    </p>
    `,
    // helpLink: `/documents/edit/new?gn.key=article-generation-guide-1&gn.stage_number=1`,
    // helpLinkText: 'Create your first article',
    // helpLinkCssClass: 'btn btn-primary btn-magic',
    // helpIconCssClass: 'bi bi-magic'
  },
  TopicExplorer: {
    shortDescription: "Boost your SEO by building topic authority. The Topic Explorer helps you uncover gaps and expand your topical coverage.",
    helpLink: ``,
    helpLinkText: ''
  }
}

export const NavHeadings = Object.freeze(HeadingInfoSet);